/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ResourceValidationError } from '../models/ResourceValidationError';

export class ValidateResourceConfigurationResponse {
  /**
  * Whether the resource configuration is valid
  */
  'isValid': boolean;
  /**
  * List of configuration validation errors
  */
  'errors': Array<ResourceValidationError>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "isValid",
      "baseName": "isValid",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "errors",
      "baseName": "errors",
      "type": "Array<ResourceValidationError>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ValidateResourceConfigurationResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

